export enum DashboardCollapsibleWidgetsEnum {
    CustomersWidget = "CUSTOMERS_WIDGET",
    IncomingInterfacesWidget = "INCOMING_INTERFACES_WIDGET",
    OutgoingInterfacesWidget = "OUTGOING_INTERFACES_WIDGET",
}
